import Swiper from 'swiper';
const computerSlider = document.querySelectorAll(".computer-slider .slider");

document.addEventListener("DOMContentLoaded", () => {
  if(computerSlider){
    computerSlider.forEach((el) => {
        var mySwiper = new Swiper (el, {
            effect: 'coverflow',
            autoplay: {
              delay: 3000,
            },
            coverflowEffect: {
                rotate: 20,
                slideShadows: false,
              },
            pagination: {
              el: el.querySelector('.slider-pagination'),
              clickable: true
            },
            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },
          })
    })
  }
})